import { Component } from '@angular/core';
import { Error } from 'src/app/shared/components/error/error.model';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-time-error',
  templateUrl: './time-error.component.html',
  styleUrls: ['./time-error.component.scss']
})
export class TimeErrorComponent {
  assetsUrl = environment.assetsUrl;
  accountText: string = '';
  public config: Error = {
    route: this.assetsUrl + '/images/cdt/icons/time-icon.svg',
    image: 'time-icon',
    title: 'Lo sentimos, has excedido el tiempo de espera',
    content:
      'Te invitamos a realizar nuevamente el proceso de apertura de tu producto.',
    link: {
      url: routesData.HOME.redirectPath,
      text: 'Entendido'
    }
  };
}
